const state = {
    region: null,
    env: null,
    host: null,
};

const actions = {
    setRegion({ commit }, data) {
        commit('region', data);
    },

    setEnv({ commit }, data) {
        commit('env', data);
    },

    setHost({ commit }, data) {
        commit('host', data);
    },
};

const mutations = {
    region(state, value) {
        state.region = value;
    },

    env(state, value) {
        state.env = value;
    },

    host(state, value) {
        state.host = value;
    },
};

const getters = {
    contextRegion({ region }) {
        return region;
    },

    contextEnv({ env }) {
        return env;
    },

    contextHost({ host }) {
        return host;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/context.js